import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-sand px-5 py-16 sm:py-20" data-id="element-99" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-xl text-center" data-id="element-100" data-mp="1o5q24hrrqa0i">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white text-brand" data-id="element-101" data-mp="223ofbjucs0ef">
          <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-102" data-mp="1x5d1ky0xt5qx" />
        </span>
        <h2 className="mt-6 font-display text-xl font-black uppercase tracking-wide text-ink sm:text-2xl" data-id="element-103" data-mp="19dzcd0y31qa6">
          Get Your Money Back Or Keep It
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-ink/60" data-id="element-104" data-mp="14dtgt9oozjmt">
          7-day no-questions-asked guarantee. If it&apos;s not what you expected
          or doesn&apos;t save you hours of work, we&apos;ll refund you. Just
          email us.
        </p>
        <a href="#faq" className="mt-5 inline-block text-xs font-bold text-brand underline underline-offset-4 transition-colors hover:text-brand-dark" data-id="element-105" data-mp="qmokaggmf7gp">
          Full refund policy
        </a>
      </div>
    </section>;
}